import addHome1 from '../img/addHome1.jpg';
import addHome2 from '../img/addHome2.jpg';
import addHome3 from '../img/addHome3.jpg';
import { Link } from 'react-router-dom';

const Help = () => {
	return (
		<div className="help-page page">
			<div className="guide-cont flex-col-start">
				<h1>Add to Home Screen</h1>
				<p>Be sure to add to home screen to get app experience </p>
				<h3>click the three dots on your browser</h3>
				<img src={addHome1} />

				<h3>click add to home screen and follow the steps</h3>
				<img src={addHome2} />

				<h3>
					lastly it appears at home screen.And thats its easy steps don't miss out ,have the app experience
				</h3>

				<img src={addHome3} />

				<h1>Your Done</h1>
				<p>Welcome to am beats </p>

				<button>
					<a href="/"> Done</a>
				</button>
			</div>
		</div>
	);
};

export default Help;
